<div :class="['no-result-div', { 'no-result-div-vertical': verticalAllignment }]">
    <img :src="iconToShow" :height="imgHeight" :width="imgWidth" alt="No results" />
    <div class="no-result-text">
        <MdTypography tag="h6" :variant="titleVariant">
            {{noResultsTitle}}
        </MdTypography>
        <MdTypography class="no-result-text-desc" tag="span" :variant="contentVariant" color="spirits--600" v-html="noResultsContent">

        </MdTypography>
    </div>
</div>